import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import AstrologyWebsite from "@/components/AstrologyWebsite";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<AstrologyWebsite />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
